import {useState} from 'react'
import {PanelList} from '@github-ui/panel-list'
import {IconButton} from '@primer/react'
import type {RuleConfig} from '../types'
import {RuleProviderRow} from './rule-provider-row'
import {ChevronDownIcon, ChevronRightIcon} from '@primer/octicons-react'
import styles from './leading-icon-button.module.css'

export type RuleRowProps = {
  ruleConfig: RuleConfig
}
export function RuleRow({ruleConfig}: RuleRowProps) {
  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <>
      <PanelList.Row key={ruleConfig.type}>
        <PanelList.Row.LeadingVisual>
          <div className={styles.LeadingIconButtonContainer}>
            <IconButton
              variant="invisible"
              onClick={() => setIsExpanded(!isExpanded)}
              icon={isExpanded ? ChevronDownIcon : ChevronRightIcon}
              aria-label={`${isExpanded ? 'Hide' : 'Show'} rule configurations`}
            />
          </div>
        </PanelList.Row.LeadingVisual>
        <strong className="d-flex flex-items-center">{ruleConfig.displayName}</strong>
        <PanelList.Row.Description>
          <div className="fgColor-muted text-small">
            {ruleConfig.description ? <div>{ruleConfig.description}</div> : null}
          </div>
        </PanelList.Row.Description>
      </PanelList.Row>
      {isExpanded &&
        ruleConfig.ruleProviders.map(provider => (
          <RuleProviderRow key={provider.name} provider={provider} fields={ruleConfig.parameterSchema.fields} />
        ))}
    </>
  )
}
